import Shadow from '$tablet-app/src/app/components/Shadow';
import { palette } from '$tablet-app/src/app/theme';
import styled from 'styled-components/native';

const DashboardPanel = styled(Shadow)`
  background-color: ${palette.white};
  border-radius: 22px;
`;

export default DashboardPanel;
